
export default {
  log: function (msg) {
    console.log(msg)
  },
  isJSON: function (str) {
    try {
      return (JSON.parse(str) && !!str);
    } catch (e) {
      return false;
    }
  },
  isKeyValue: function (str) {
    try {
      (JSON.parse(str) && !!str);
      return Boolean(Object.keys(JSON.parse(str)).length)
    } catch (e) {
      return false;
    }
  },
  equal: function (obj1, obj2) {
    return JSON.stringify(obj1) == JSON.stringify(obj2);
  },
  toKababCase: function (str) {
    return str.replace(/[A-Z]/g, (match, offset, string) => { return (offset > 0 ? '-' : '') + match.toLowerCase(); })
  },
  toKababCaseFeatherIcon: function (str) {
    return 'icon-' + str.replace('Icon', '').replace(/[A-Z]/g, (match, offset, string) => { return (offset > 0 ? '-' : '') + match.toLowerCase(); })
  },
  isMerchant() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"))
    if (userInfo && userInfo.userRole) {
      if (userInfo.userRole == 'Merchant')
        return true;
      else if (Array.isArray(userInfo.userRole)
        && userInfo.userRole.find(x => x == 'Merchant')
      ) {
        return true;
      }
      return false;
    }
  },
  selectAccount(){
    //Implementation in ProfileDropDown.vue
  },
  copy(){
    //Implementation in App.vue
  }
}


// console.log('%%%%');
// function log1(msg) {
//   console.log(msg)
// }